export default __webpack_public_path__ + "static/SuisseIntl-SemiBold-aac57bd2364e016a4dabb5ed6a4e04a8.woff";